import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class VoodooAnimation extends Phaser.Group {

    private static NUMBER_OF_HITS = 2;

    private handImage: Phaser.Image;
    private dollHits: number;

    constructor(game: Phaser.Game) {

        super(game, null, "voodoo animation", false);

        const doll = new Phaser.Image(this.game, 25, GameConstants.GAME_HEIGHT, "texture_atlas_5", "vudu_muneco");
        doll.anchor.set(0, 1);
        doll.scale.y = GameVars.scaleY;
        this.add(doll);

        this.handImage = new Phaser.Image(this.game, -25, 600, "texture_atlas_5", "vudu_mano");
        this.handImage.scale.y = GameVars.scaleY;
        this.add(this.handImage);

        this.dollHits = 0;

        this.game.add.tween(this.handImage)
            .to({ y: 675 }, 500, Phaser.Easing.Elastic.In, true)
            .onComplete.add(this.handTweenOut, this);
    }

    private handTweenOut(): void {

        this.dollHits++;
        this.game.add.tween(this.handImage)
            .to({ y: 600 }, 1000, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(this.handTweenIn, this);
    }

    private handTweenIn(): void {

        if (this.dollHits === VoodooAnimation.NUMBER_OF_HITS) {

            this.game.add.tween(this)
                .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(this.destroy, this);
        } else {
            this.game.add.tween(this.handImage)
                .to({ y: 675 }, 500, Phaser.Easing.Elastic.In, true)
                .onComplete.add(this.handTweenOut, this);
        }
    }
}
